export default {"src":"/_next/static/media/card-visa.8d125711.svg","height":16,"width":24,"blurWidth":0,"blurHeight":0};